<template>
  <base-content-block :back-name="'users'">
    <template #title>
      {{ title }}
    </template>
    <template #content>
      <user-form v-model="user" :excluded-logins="excludedLogins" :saving="saving" @submit="save"></user-form>
    </template>
  </base-content-block>
</template>

<script>
import { userStatus } from '@/main.config.js'
import http from '@/modules/http.js'
import { contentTpl } from '@/mixins/content-tpl.js'
import { systemUnavailable } from '@/mixins/system-unavailable.js'

export default {
  name: 'UserAdd',
  mixins: [contentTpl, systemUnavailable],
  components: {
    UserForm: () => import('@/components/UserForm.vue')
  },
  data: () => ({
    user: {
      user_roles: [],
      status: userStatus.unregistered
    },
    saving: false,
    excludedLogins: []
  }),
  mounted() {
    if (this.role) {
      this.user.user_roles.push(this.role)
    }
  },
  computed: {
    role() {
      return this.$route.meta.addRole
    },
    hospitalId() {
      return this.$store.getters.SELECTED_HOSPITAL
    }
  },
  methods: {
    save() {
      this.saving = true
      if (this.hospitalId) {
        this.user.hospital_id = this.hospitalId
      }

      http
        .post('/users', this.user)
        .then(response => response.data)
        .then(data => {
          this.user = data
        })
        .then(() => {
          this.$router.push({
            name: 'user-edit',
            params: { id: this.user.id }
          })
        })
        .catch(error => {
          if (error.response.data.message === 'The system has expired') {
            this.$emit('system:unavailable')
          }
          if (error.response.status === 409) {
            this.excludedLogins.push(this.user.login)
          } else if (error.response.code === 400) {
            console.error(error.response.message)
          }
        })
        .finally(() => (this.saving = false))
    }
  }
}
</script>
